<button
	*ngIf="!hidden"
	class="action-button"
	[ngClass]="disabled ? ['disabled', type] : type"
	[disabled]="disabled"
	(click)="handleClick()"
>
	<ng-content></ng-content>
</button>
